import type { BaseMeeting } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { Countdown, Icon } from '@swf/sports/components';

import { useSportsAnimalRacingMeetingsWidget } from '../../model';

import { TXTWCL_N0_Race_1, TXTWCL_N0_Races } from './MeetingTitle.messages.json';
import styles from './MeetingTitle.scss';

export interface Props {
  isOpen: boolean;
  meeting: BaseMeeting;
}

const MeetingTitle: React.FC<Props> = ({ meeting, isOpen }) => {
  const { widgetSelect } = useSportsAnimalRacingMeetingsWidget();
  const { venue, id } = meeting;
  const races = useSelector((state: RootState) => widgetSelect.meetingRaces(state, id));

  if (!races.length) return null;

  const [{ startTime }] = races;
  const raceCountMessage = races.length > 1 ? TXTWCL_N0_Races : TXTWCL_N0_Race_1;

  return (
    <div className={styles.titleWrapper}>
      <Icon
        name="chevron-medium-down"
        className={classNames(styles.icon, {
          [styles.iconOpen]: isOpen
        })}
        size="lg"
      />
      <span>
        <span>
          {venue}{' '}
          <span className={styles.raceCount}>
            <Translation {...raceCountMessage} values={{ 0: races.length }} />
          </span>
        </span>
        <span className={styles.raceCountdown}>
          <Countdown countdownDate={startTime} />
        </span>
      </span>
    </div>
  );
};

export default MeetingTitle;
